<template>
  <HvhChart :visualization="visualization" />
</template>

<script>
import HvhChart from './HvhChart.vue';
import Legend from './KaplanMeierLegend.vue';
import { generateColors } from '../../libraries/charts/chartCommon';
export default {
  components: { HvhChart, Legend },
  props: ['chartData'],
  computed: {
    grouped() {
      var entries = Object.entries(this.chartData);
      var colors = generateColors(entries.length);
      return entries.map(([name, value], ind) => {
        var filtered = {
          t: value.t.filter((_, i) => i % 2 === 0),
          'S(t)': value['S(t)'].filter((_, i) => i % 2 === 0),
          StdDev: value.StdDev.filter((_, i) => i % 2 !== 0)
        };
        var min = Math.min(...filtered.t);
        var max = Math.max(...filtered.t);
        var data = Array.from({ length: max - min + 1 }, (_, i) => min + i)
          .reduce((acc, f) => {
            var ind = filtered.t.indexOf(f);
            if (ind === -1) {
              acc.push([f, acc[acc.length - 1][1], acc[acc.length - 1][2]]);
            } else {
              acc.push([f, filtered['S(t)'][ind], filtered.StdDev[ind]]);
            }
            return acc;
          }, []);

        return { name, data, color: colors[ind] };
      });
    },
    visualization() {
      return {
        visualization_type: "kaplanmeierchart",
        data: this.grouped,
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisKaplanMeierChart'] = this;
  }
}
</script>

<style lang="scss" scoped>
</style>